<app-patient-profile *ngIf="this.posting!=null && this.posting==false" [patient_guid]='this.patient_guid'
    [consultation_id]='this.consultation_id' [token]="this.token"></app-patient-profile>

<h4 *ngIf="this.posting!=null && this.posting==true">Fetching your message...</h4>
<p-progressSpinner [style]="{width: '50px', height: '50px'}" *ngIf="this.posting!=null && this.posting==true"
    strokeWidth="6"></p-progressSpinner>
